module.exports = __webpack_public_path__ + "static/media/subtract_filled.6fa43dbc.svg";